import { styled } from "theme/default/styled";
import { setFlexDFFDC } from "theme/setter/setFlexValues/setFlexDFFDC";

export const SUsersDetailsContent = styled.div`
  ${setFlexDFFDC};
`;
